import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import AdminDashboard from './components/admin/AdminDashboard';
import EmployeeDashboard from './components/employee/EmployeeDashboard';
import SuperAdminDashboard from './components/superadmin/SuperAdminDashboard';
import CandidateOnboarding from './components/candidate/CandidateOnboarding';
import ProtectedRoute from './components/common/ProtectedRoute';
import LoadingSpinner from './components/common/LoadingSpinner';
import config from './config/config';
import { logConfig } from './utils/configUtils';
import { homePathForUser } from './utils/authRouting';

function AppContent() {
  const { user, loading } = useAuth();

  // Debug: Log user data for routing
  console.log('App routing - User:', user);
  console.log('App routing - User role:', user?.role);
  console.log('App routing - User employeeId:', user?.employeeId);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          
          <Route
            path="/login"
            element={user ? <Navigate to={homePathForUser(user)} /> : <Login />}
          />

          <Route
            path="/candidate"
            element={
              <ProtectedRoute allowedRoles={['employee']} allowCandidate>
                <CandidateOnboarding />
              </ProtectedRoute>
            }
          />

          <Route 
            path="/admin/*" 
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/employee/*" 
            element={
              <ProtectedRoute allowedRoles={['employee']}>
                <EmployeeDashboard />
              </ProtectedRoute>
            } 
          />

          <Route
            path="/superadmin/*"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperAdminDashboard />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/"
            element={<Navigate to={homePathForUser(user)} />}
          />
          
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        
        <ToastContainer
          position={config.TOAST_POSITION}
          autoClose={config.TOAST_DURATION}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Router>
  );
}

function App() {
  // Log configuration in development mode
  logConfig();

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
